export const BASE_URL = window.location.protocol + "//" + window.location.host;
// export const STORY_BASE_URL = (window.location.protocol + "//" + window.location.host).replace('www.','story.');

export const STORY_BASE_URL = 'https://story.get-tesla-us.com';


const Endpoint = {
    POST_TO_ADDRESS: '/api/index/address',
    ME: '/user/getUserinfo',
    
    STORY_DETAIL: '/index.php/api/Tiezi/getTiezi',
    STORY_COMMENT_LIST: '/index.php/api/Pinglun/getPinglunlisttiezi',

    UPLOAD: '/api/common/upload',
    ORDER: '/api/index/index',
    ORDER_DETAIL: '/api/index/getOrderInfoByOrderNo',
    ORDER_UPDATE: '/api/index/updateOrder',
    ORDER_STATUS_UPDATE: '/api/index/webhooksfb',
    TRANSLATION: '/api/Urlrelation/getUrlrelationUrl',
    PIXEL: '/api/Urlrelation/getUrlrelationUrl',
    FB_CONVERSION_EVENT: '/api/facebook/EventsAll',
    CUSTOM_EVENT: '/api/Events/addevent',
    SUBMIT_ORDER:'/api/index/peng'
}
export default Endpoint;

export const DEFAULT_PIXEL_ID = '1725028751465154';
export const DEFAULT_FBQ_TOKEN = 'EAAO7Cc2CdPIBPGxcaQTKq8kdlVyFYyP4mIxDJWCzSgZBX4Ntzo7NB9vrxK5XXXEf1GxSSpKhZCwhZBDhatxjyhGiRPetqRQVXqKKpNLxLK3DNldF8sUDklczIGTMUzffmNzUZBt1gBVw7f74HmUhQoZAPWlMY4tR2PvCTMsbMxnZA8kBP5s5x2Q2rRhsQ0rLzicAZDZD';
